var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning_lender"},[_vm._v(" "+_vm._s(_vm.$t('peringatan'))+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }